var path = 'ui-formly/types/header/index.html';
var html = "<div class=\"mishion_history\">\r\n  <div class=\"mission_title\">{{to.headerText}}</div>\r\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;